/**
 * Platform detection utilities for UI adaptations
 * (e.g., displaying platform-specific keyboard shortcuts)
 */

let isMacPlatform = false;
if (typeof navigator !== 'undefined') {
  isMacPlatform = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
}

/**
 * Whether the user is on a Mac/iOS platform
 */
export const isMac = isMacPlatform;

/**
 * Returns the platform-specific modifier key symbol
 * - Mac: ⌘ (Command)
 * - Windows/Linux: Ctrl
 */
export const getModifierSymbol = (): string => (isMac ? '⌘' : 'Ctrl');

/**
 * Returns the platform-specific modifier key label
 * - Mac: Cmd
 * - Windows/Linux: Ctrl
 */
export const getModifierLabel = (): string => (isMac ? 'Cmd' : 'Ctrl');
